// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock6-space1-S4jdU {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock6-space2-YBdLM {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock6-space3-VVMHo {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock6-space4-D3rzv {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock6-space5-JhLc5 {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock6-space6-afjY1 {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock6-space7-oFy5Y {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock6-space8-Ung6W {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock6-spaceTop1-MGGkT {
	margin-top: 6px !important;
}

.WhyHostFormBlock6-spaceTop2-boGQR {
	margin-top: 12px !important;
}

.WhyHostFormBlock6-spaceTop3-nV_iP {
	margin-top: 18px !important;
}

.WhyHostFormBlock6-spaceTop4-JFkGm {
	margin-top: 24px !important;
}

.WhyHostFormBlock6-spaceTop5-aHmVV {
	margin-top: 30px !important;
}

.WhyHostFormBlock6-spaceTop6-LMlA1 {
	margin-top: 36px !important;
}

.WhyHostFormBlock6-spaceTop7-ViejD {
	margin-top: 42px !important;
}

.WhyHostFormBlock6-spaceTop8-FmQHC {
	margin-top: 48px !important;
}

.WhyHostFormBlock6-noMargin-Xpe8C {
	margin: 0px !important;
}

.WhyHostFormBlock6-padding1-jrVou {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock6-padding2-fgsui {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock6-padding3-rDIV1 {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock6-padding4-JswGt {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock6-padding5-c90_J {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock6-padding6-wSAex {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock6-padding7-rhSCJ {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock6-paddingTop1-u3V8G {
	padding-top: 6px !important;
}

.WhyHostFormBlock6-paddingTop2-WgwBY {
	padding-top: 12px !important;
}

.WhyHostFormBlock6-paddingTop3-qHqX5 {
	padding-top: 18px !important;
}

.WhyHostFormBlock6-paddingTop4-qo2U4 {
	padding-top: 24px !important;
}

.WhyHostFormBlock6-paddingTop5-jKYO6 {
	padding-top: 30px !important;
}

.WhyHostFormBlock6-paddingTop6-j8WBU {
	padding-top: 36px !important;
}

.WhyHostFormBlock6-paddingTop7-Rfpwd {
	padding-top: 42px !important;
}

.WhyHostFormBlock6-noPadding-B0IuZ {
	padding: 0px !important;
}

.WhyHostFormBlock6-spaceMarginBottom0-F4Rxa {
	margin-bottom: 0;
}

.WhyHostFormBlock6-textBold-RwOln {
	font-weight: 500 !important;
}

.WhyHostFormBlock6-textBolder-SZAT1 {
	font-weight: 700 !important;
}

.WhyHostFormBlock6-textNormal-I09uA {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock6-textDarkBlue-weMNd {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock6-textLightBlue-qXKZf {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock6-textLightSandleGreen-eA7pw {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock6-textLightBrown-sJZSq {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock6-textMediumMaroon-svSCX {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock6-textBrown-BUoMP {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock6-textMaroon-IJllk {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock6-textDarkBrown-sdLzl {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock6-textMediumBrown-spxCb {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock6-textSkyBlue-W02pi {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock6-textGray-Bx_k1 {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock6-errorMessage-l65Kb {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock6-userText-XTfxk {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock6-panelHeader-hEmsl {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock6-exportSection-nDfPl {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock6-exportSectionGridSub-IJ8ZT {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock6-exportText-xNU_b {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock6-exportLinkImg-r2tz8 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock6-exportImg-ozWHO {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock6-linkBtn-MQm19 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock6-table-BaEfx {
	display: table;
}

.WhyHostFormBlock6-tableRow-gTTtN {
	display: table-row;
}

.WhyHostFormBlock6-tableCell-XLctl {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock6-formGroup-ywIdl {
	margin-bottom: 6px;
}

.WhyHostFormBlock6-marginTop0-mSUxV {
	margin-top: 0;
}

.WhyHostFormBlock6-marginBottom20-W_n0i {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock6-bannerImageBg-soULi {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock6-bannerDelete-Js_wy {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock6-exportLink-BSVwI {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock6-seachContent-TwuvS {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock6-marginBottom9-awTUF {
	margin-bottom: 9px;
}

.WhyHostFormBlock6-spaceTop52-LfG8e {
	margin-top: 52px;
}

.WhyHostFormBlock6-profileViewInner-lDwg_ {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock6-profileViewMain-Ywe8i {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock6-profileViewlabel-iT7Ld {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock6-profileViewMainContent-WJ9Wy {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock6-reviewsFormStar-qUkzJ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock6-reviewsFormStar-qUkzJ svg {
	cursor: pointer;
}

.WhyHostFormBlock6-addLanguageText-Ym6p1 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock6-exportSection-nDfPl {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock6-spaceTop52-LfG8e {
		margin-top: 18px;
	}

	.WhyHostFormBlock6-exportText-xNU_b {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock6-exportSectionGridSub-IJ8ZT {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock6-profileViewlabel-iT7Ld {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock6-profileViewMainContent-WJ9Wy {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock6-panelHeader-hEmsl {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock6-space1-S4jdU`,
	"space2": `WhyHostFormBlock6-space2-YBdLM`,
	"space3": `WhyHostFormBlock6-space3-VVMHo`,
	"space4": `WhyHostFormBlock6-space4-D3rzv`,
	"space5": `WhyHostFormBlock6-space5-JhLc5`,
	"space6": `WhyHostFormBlock6-space6-afjY1`,
	"space7": `WhyHostFormBlock6-space7-oFy5Y`,
	"space8": `WhyHostFormBlock6-space8-Ung6W`,
	"spaceTop1": `WhyHostFormBlock6-spaceTop1-MGGkT`,
	"spaceTop2": `WhyHostFormBlock6-spaceTop2-boGQR`,
	"spaceTop3": `WhyHostFormBlock6-spaceTop3-nV_iP`,
	"spaceTop4": `WhyHostFormBlock6-spaceTop4-JFkGm`,
	"spaceTop5": `WhyHostFormBlock6-spaceTop5-aHmVV`,
	"spaceTop6": `WhyHostFormBlock6-spaceTop6-LMlA1`,
	"spaceTop7": `WhyHostFormBlock6-spaceTop7-ViejD`,
	"spaceTop8": `WhyHostFormBlock6-spaceTop8-FmQHC`,
	"noMargin": `WhyHostFormBlock6-noMargin-Xpe8C`,
	"padding1": `WhyHostFormBlock6-padding1-jrVou`,
	"padding2": `WhyHostFormBlock6-padding2-fgsui`,
	"padding3": `WhyHostFormBlock6-padding3-rDIV1`,
	"padding4": `WhyHostFormBlock6-padding4-JswGt`,
	"padding5": `WhyHostFormBlock6-padding5-c90_J`,
	"padding6": `WhyHostFormBlock6-padding6-wSAex`,
	"padding7": `WhyHostFormBlock6-padding7-rhSCJ`,
	"paddingTop1": `WhyHostFormBlock6-paddingTop1-u3V8G`,
	"paddingTop2": `WhyHostFormBlock6-paddingTop2-WgwBY`,
	"paddingTop3": `WhyHostFormBlock6-paddingTop3-qHqX5`,
	"paddingTop4": `WhyHostFormBlock6-paddingTop4-qo2U4`,
	"paddingTop5": `WhyHostFormBlock6-paddingTop5-jKYO6`,
	"paddingTop6": `WhyHostFormBlock6-paddingTop6-j8WBU`,
	"paddingTop7": `WhyHostFormBlock6-paddingTop7-Rfpwd`,
	"noPadding": `WhyHostFormBlock6-noPadding-B0IuZ`,
	"spaceMarginBottom0": `WhyHostFormBlock6-spaceMarginBottom0-F4Rxa`,
	"textBold": `WhyHostFormBlock6-textBold-RwOln`,
	"textBolder": `WhyHostFormBlock6-textBolder-SZAT1`,
	"textNormal": `WhyHostFormBlock6-textNormal-I09uA`,
	"textDarkBlue": `WhyHostFormBlock6-textDarkBlue-weMNd`,
	"textLightBlue": `WhyHostFormBlock6-textLightBlue-qXKZf`,
	"textLightSandleGreen": `WhyHostFormBlock6-textLightSandleGreen-eA7pw`,
	"textLightBrown": `WhyHostFormBlock6-textLightBrown-sJZSq`,
	"textMediumMaroon": `WhyHostFormBlock6-textMediumMaroon-svSCX`,
	"textBrown": `WhyHostFormBlock6-textBrown-BUoMP`,
	"textMaroon": `WhyHostFormBlock6-textMaroon-IJllk`,
	"textDarkBrown": `WhyHostFormBlock6-textDarkBrown-sdLzl`,
	"textMediumBrown": `WhyHostFormBlock6-textMediumBrown-spxCb`,
	"textSkyBlue": `WhyHostFormBlock6-textSkyBlue-W02pi`,
	"textGray": `WhyHostFormBlock6-textGray-Bx_k1`,
	"errorMessage": `WhyHostFormBlock6-errorMessage-l65Kb`,
	"userText": `WhyHostFormBlock6-userText-XTfxk`,
	"panelHeader": `WhyHostFormBlock6-panelHeader-hEmsl`,
	"exportSection": `WhyHostFormBlock6-exportSection-nDfPl`,
	"exportSectionGridSub": `WhyHostFormBlock6-exportSectionGridSub-IJ8ZT`,
	"exportText": `WhyHostFormBlock6-exportText-xNU_b`,
	"exportLinkImg": `WhyHostFormBlock6-exportLinkImg-r2tz8`,
	"exportImg": `WhyHostFormBlock6-exportImg-ozWHO`,
	"linkBtn": `WhyHostFormBlock6-linkBtn-MQm19`,
	"table": `WhyHostFormBlock6-table-BaEfx`,
	"tableRow": `WhyHostFormBlock6-tableRow-gTTtN`,
	"tableCell": `WhyHostFormBlock6-tableCell-XLctl`,
	"formGroup": `WhyHostFormBlock6-formGroup-ywIdl`,
	"marginTop0": `WhyHostFormBlock6-marginTop0-mSUxV`,
	"marginBottom20": `WhyHostFormBlock6-marginBottom20-W_n0i`,
	"bannerImageBg": `WhyHostFormBlock6-bannerImageBg-soULi`,
	"bannerDelete": `WhyHostFormBlock6-bannerDelete-Js_wy`,
	"exportLink": `WhyHostFormBlock6-exportLink-BSVwI`,
	"seachContent": `WhyHostFormBlock6-seachContent-TwuvS`,
	"marginBottom9": `WhyHostFormBlock6-marginBottom9-awTUF`,
	"spaceTop52": `WhyHostFormBlock6-spaceTop52-LfG8e`,
	"profileViewInner": `WhyHostFormBlock6-profileViewInner-lDwg_`,
	"profileViewMain": `WhyHostFormBlock6-profileViewMain-Ywe8i`,
	"profileViewlabel": `WhyHostFormBlock6-profileViewlabel-iT7Ld`,
	"profileViewMainContent": `WhyHostFormBlock6-profileViewMainContent-WJ9Wy`,
	"reviewsFormStar": `WhyHostFormBlock6-reviewsFormStar-qUkzJ`,
	"addLanguageText": `WhyHostFormBlock6-addLanguageText-Ym6p1`
};
module.exports = ___CSS_LOADER_EXPORT___;
